import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=0a15c25e&scoped=true&"
import script from "./VideoCard.vue?vue&type=script&lang=js&"
export * from "./VideoCard.vue?vue&type=script&lang=js&"
import style0 from "./VideoCard.vue?vue&type=style&index=0&id=0a15c25e&prod&scoped=true&lang=scss&"
import style1 from "./VideoCard.vue?vue&type=style&index=1&id=0a15c25e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a15c25e",
  null
  
)

export default component.exports